import React, {useState} from 'react';
import clsx from "clsx";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import {Divider, Paper} from "@mui/material";
import ListItemText from "@mui/material/ListItemText";
import {BaseStyle} from "../../../../styles/shared/BaseStyle";
import SmsTwoToneIcon from '@mui/icons-material/SmsTwoTone';
import BathtubTwoToneIcon from "@mui/icons-material/BathtubTwoTone";
import ChildCareTwoToneIcon from '@mui/icons-material/ChildCareTwoTone';
import BookTwoToneIcon from '@mui/icons-material/BookTwoTone';
import HourglassEmptyTwoToneIcon from '@mui/icons-material/HourglassEmptyTwoTone';
import HourglassFullTwoToneIcon from '@mui/icons-material/HourglassFullTwoTone';

const IntervisteDrawer = ({selectMenuItem, stato}) => {
	const classes = BaseStyle();
	
	const [open, setOpen] = useState(true);
	
	const handleDrawerOpenClose = () => {
		setOpen(!open);
	};
	
	return (
        <React.Fragment>
            <Paper
				className={clsx(classes.drawer, classes.roundBorder, open ? classes.openDrawer : classes.closedDrawer)}>
				<div style={{display: "flex", justifyContent: "center"}}>
					<Tooltip title={open ? "Comprimi menù" : "Espandi menù"}>
						<IconButton onClick={handleDrawerOpenClose} size="large">
							{!open ? <ChevronRightIcon/> : <ChevronLeftIcon/>}
						</IconButton>
					</Tooltip>
				</div>
				<List>
					<ListItem disabled button className={classes.roundBorder} selected={stato === "Incomplete operatore"}
					          onClick={() => selectMenuItem("Incomplete operatore")}>
						<ListItemIcon>
							<BookTwoToneIcon/>
						</ListItemIcon>
						<ListItemText primary={"Incomplete operatore"}/>
					</ListItem>
					<ListItem disabled button className={classes.roundBorder} selected={stato === "In attesa"}
					          onClick={() => selectMenuItem("In attesa")}>
						<ListItemIcon>
							<HourglassEmptyTwoToneIcon/>
						</ListItemIcon>
						<ListItemText primary={"In attesa cittadino"}/>
					</ListItem>
					<ListItem disabled button className={classes.roundBorder} selected={stato === "Compilata cittadino"}
					          onClick={() => selectMenuItem("Compilata cittadino")}>
						<ListItemIcon>
							<HourglassFullTwoToneIcon/>
						</ListItemIcon>
						<ListItemText primary={"Compilata cittadino"}/>
					</ListItem>
					<ListItem disabled button className={classes.roundBorder} selected={stato === "In gestione INC"}
					          onClick={() => selectMenuItem("In gestione INC")}>
						<ListItemIcon>
							<BathtubTwoToneIcon/>
						</ListItemIcon>
						<ListItemText primary={"In gestione (Incomplete)"}/>
					</ListItem>
				</List>
				<Divider/>
				<List>
					<ListItem button className={classes.roundBorder} selected={stato === "Complete"}
					          onClick={() => selectMenuItem("Complete")}>
						<ListItemIcon>
							<SmsTwoToneIcon/>
						</ListItemIcon>
						<ListItemText primary={"Complete"}/>
					</ListItem>
					<ListItem button className={classes.roundBorder} selected={stato === "In gestione CMP"}
					          onClick={() => selectMenuItem("In gestione CMP")}>
						<ListItemIcon>
							<ChildCareTwoToneIcon/>
						</ListItemIcon>
						<ListItemText primary={"In gestione (Complete)"}/>
					</ListItem>
				</List>
			</Paper>
        </React.Fragment>
    );
};

export default React.memo(IntervisteDrawer)
